import { GingerMediaBaseUrl } from "./baseUrls";

export async function deleteVendorDetails(vendorId: string) {
    return fetch(`${GingerMediaBaseUrl}/deleteVendorDetails?vendorId=${vendorId}`,
        {
            method: 'DELETE',
        }
    );
}